import { render, staticRenderFns } from "./SelectBundle.vue?vue&type=template&id=b88f9b68&scoped=true&"
import script from "./SelectBundle.vue?vue&type=script&lang=js&"
export * from "./SelectBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88f9b68",
  null
  
)

export default component.exports